import React from 'react';
import { useIntl } from 'ha/i18n';
import Track from 'ha/components/track/SmartTrack';
import { Grid, Link, Typography } from '@ha/dsl';

interface Props {
  nextUrl?: string;
  onSwitch: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const FormSwitch: React.FC<Props> = ({ nextUrl, onSwitch }) => {
  const { T, urlResolver } = useIntl();

  return (
    <Grid container item spacing={1} alignItems="center" justify="center">
      <Grid item>
        <Typography.Paragraph>
          {T('Already have an account?')}
        </Typography.Paragraph>
      </Grid>
      <Grid item>
        <Track name="Clicked Already have an account" type="link">
          <Link
            kind="mint-underline"
            to={urlResolver.getLoginUrl(nextUrl)}
            onClick={onSwitch}
            data-test-locator="Already have an account"
          >
            {T('Log in')}
          </Link>
        </Track>
      </Grid>
    </Grid>
  );
};

export default FormSwitch;
